import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDirectivesModule } from 'src/app/directives/shared-directives.module';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { CadastroEnderecoModule } from '../common/cadastro-endereco/cadastro-endereco.module';
import { CadastrarMatriculaSecretariaComponent } from './cadastrar-matricula-secretaria/cadastrar-matricula-secretaria.component';
import { MatriculaSecretariaRoutingModule } from './matricula-secretaria-routing.module';
import { MatriculaSecretariaComponent } from './matricula-secretaria.component';




@NgModule({
  declarations: [MatriculaSecretariaComponent, CadastrarMatriculaSecretariaComponent],
  imports: [
    CommonModule,
    MatriculaSecretariaRoutingModule,
    MaterialCommonModule,
    SharedDirectivesModule,
    CadastroEnderecoModule
  ]
})
export class MatriculaSecretariaModule { }
